module.exports = __webpack_public_path__ + "static/media/close-circle.764410c9.svg";